/**
 * Created by Danila Krupnov on 9/9/25
 */

const CupsConfig = {
    aa: {
        price: 30,
        amount: 8,
        stage0: {
            lockDuration: "8 minutes",
            probabilities: [0.25, 0.125, 0.125, 0.25, 0.25],
            rewards: ["AB0", "CD0", "E0", "qq0", "rr0"]
        },
        stage1: {
            lockDuration: "20 minutes",
            probabilities: [0.166, 0.083, 0.083, 0.083, 0.083, 0.252, 0.25],
            rewards: ["AB1", "CD1", "E1", "qq1", "rr0", "qq1", "rr1"]
        }
    },

    bb: {
        price: 30,
        amount: 8,
        stage0: {
            lockDuration: "8 minutes",
            probabilities: [0.25, 0.125, 0.125, 0.25, 0.25],
            rewards: ["GH0", "F0", "I0", "qq0", "rr0"]
        },
        stage1: {
            lockDuration: "20 minutes",
            probabilities: [0.166, 0.083, 0.083, 0.083, 0.083, 0.252, 0.25],
            rewards: ["GH1", "F1", "I1", "qq1", "rr0", "qq1", "rr1"]
        }
    },

    cc: {
        price: 30,
        stage0: {
            lockDuration: "5 seconds",
            amount: 6,
            probabilities: [0.5, 0.5],
            rewards: ["qq0", "pp0"]
        },
        stage1: {
            lockDuration: "5 seconds",
            amount: 10,
            probabilities: [0.2, 0.2, 0.3, 0.1, 0.1, 0.1],
            rewards: ["pp0", "pp1", "qq0", "qq1", "rr0", "rr1"]
        },
        stage2: {
            lockDuration: "5 seconds",
            amount: 15,
            probabilities: [0.203, 0.20, 0.066, 0.2, 0.133, 0.066, 0.066, 0.066],
            rewards: ["pp0", "pp1", "pp2", "qq0", "qq1", "qq2", "rr0", "rr1"]
        }
    },

    dd: {
        price: 30,
        amount: 5,
        stage0: {
            lockDuration: "5 seconds",
            probabilities: [0.4, 0.6],
            rewards: ["qq0", "pp0"]
        },
        stage1: {
            lockDuration: "5 seconds",
            amount: 11,
            probabilities: [0.363, 0.09, 0.457, 0.09],
            rewards: ["qq0", "qq1", "pp0", "pp1"]
        },
        stage2: {
            lockDuration: "5 seconds",
            probabilities: [0.351, 0.13, 0.043, 0.347, 0.086, 0.043],
            rewards: ["qq0", "qq1", "qq2", "pp0", "pp1", "pp2"]
        }
    },

    ee: {
        price: 30,
        amount: 6,
        probabilities: [0.335, 0.166, 0.333, 0.166],
        rewards: ["qq0", "qq1", "rr0", "rr1"]
    },

    ff: {
        price: 30,
        amount: 5,
        stage0: {
            amount: 9,
            probabilities: [0.55, 0.45],
            rewards: ["b2", "b1"]
        },
        stage1: {
            probabilities: [0.25, 0.2, 0.05, 0.25, 0.2, 0.05],
            rewards: ["a2", "a3", "b2", "c2", "c3", "d2"]
        },
        stage2: {
            amount: 9,
            probabilities: [0.55, 0.45],
            rewards: ["d2", "d1"]
        },
        stage3: {
            amount: 8,
            probabilities: [0.5, 0.5], 
            rewards: ["e2", "e3"]
        },
        stage4: {
            probabilities: [0.4, 0.3, 0.2, 0.1],
            rewards: ["pp0", "pp1", "pp2", "pp3"]
        },
        stage5: {
            probabilities: [0.4, 0.3, 0.2, 0.1],
            rewards: ["qq0", "qq1", "qq2", "qq3"]
        },
        stage6: {
            amount: 8,
            probabilities: [0.38, 0.12, 0.38, 0.12],
            rewards: ["qq0", "qq1", "pp0", "pp1"]
        },
        stage7: {
            amount: 1,
            probabilities: [0.17, 0.11, 0.05, 0.16, 0.11, 0.05, 0.19, 0.11, 0.05],
            rewards: ["qq2", "qq3", "qq4", "rr1", "rr2", "rr3", "pp1", "pp2", "pp3"]
        }
    },

    uu: {
        price: 30,
        amount: 10,
        probabilities: [0.1, 0.1, 0.3, 0.1, 0.1, 0.3],
        rewards: ["a2", "a3", "a4", "c2", "c3", "c4"]
    },

    xx: {
        price: 30,
        stage0: {
            amount: 12,
            probabilities: [0.166, 0.211, 0.041, 0.208, 0.208, 0.166],
            rewards: ["rr0", "rr1", "rr2", "pp0", "pp1", "pp2"]
        },
        stage1: {
            amount: 8,
            probabilities: [0.25, 0.25, 0.25, 0.125, 0.125],
            rewards: ["rr0", "rr1", "pp0", "pp1", "pp2"]
        },
        stage2: {
            amount: 10,
            probabilities: [0.2, 0.3, 0.2, 0.15, 0.15],
            rewards: ["rr0", "rr1", "pp0", "pp1", "pp2"]
        },
        stage3: {
            amount: 12,
            probabilities: [0.166, 0.211, 0.041, 0.208, 0.208, 0.166],
            rewards: ["rr0", "rr1", "rr2", "pp0", "pp1", "pp2"]
        },
        stage4: {
            amount: 8,
            probabilities: [0.25, 0.25, 0.25, 0.125, 0.125],
            rewards: ["rr0", "rr1", "pp0", "pp1", "pp2"]
        }
    },

    Ab: {
        price: 30,
        stage0: {
            lockDuration: "5 seconds",
            amount: 6,
            probabilities: [0.5, 0.125, 0.25, 0.125],
            rewards: ["a4", "a5", "b2", "rr2"]
        },
        stage1: {
            lockDuration: "5 seconds",
            amount: 8,
            probabilities: [0.3, 0.2, 0.1, 0.2, 0.1, 0.1],
            rewards: ["a5", "a6", "b2", "b3", "rr2", "rr3"]
        },
        stage2: {
            lockDuration: "5 seconds",
            amount: 10,
            probabilities: [0.222, 0.222, 0.445, 0.111],
            rewards: ["a5", "a6", "b3", "rr3"]
        }
    },

    Ei: {
        price: 30,
        stage0: {
            lockDuration: "5 seconds",
            amount: 6,
            probabilities: [0.6, 0.1, 0.3],
            rewards: ["e2", "GH0", "i2"]
        },
        stage1: {
            lockDuration: "5 seconds",
            amount: 8,
            probabilities: [0.153, 0.387, 0.153, 0.307],
            rewards: ["e2", "e3", "GH0", "e4"]
        },
        stage2: {
            lockDuration: "5 seconds",
            amount: 10,
            probabilities: [0.387, 0.153, 0.23, 0.23],
            rewards: ["e3", "e4", "GH0", "i1"]
        }
    },

    Cf: {
        price: 30,
        stage0: {
            lockDuration: "5 seconds",
            amount: 6,
            probabilities: [0.419, 0.083, 0.166, 0.083, 0.166, 0.083],
            rewards: ["c3", "c4", "d2", "d3", "f2", "rr2"]
        },
        stage1: {
            lockDuration: "5 seconds",
            amount: 8,
            probabilities: [0.071, 0.214, 0.36, 0.071, 0.142, 0.071, 0.071],
            rewards: ["c4", "c5", "d2", "d3", "f2", "f3", "rr3"]
        },
        stage2: {
            lockDuration: "5 seconds",
            amount: 10,
            probabilities: [0.272, 0.038, 0.23, 0.115, 0.038, 0.192, 0.115],
            rewards: ["c4", "c5", "d3", "d4", "f2", "f3", "rr3"]
        }
    },

    Ai: {
        price: 30,
        stage0: {
            amount: 8,
            probabilities: [0.029, 0.059, 0.059, 0.133, 0.029, 0.059, 0.059, 0.119, 0.041, 0.077, 0.053, 0.035, 0.077, 0.053, 0.041, 0.077],
            rewards: ["a3", "a4", "b2", "b3", "c3", "c4", "d2", "d3", "e2", "e3", "f2", "g3", "g4", "h2", "i3", "i4"]
        },
        stage1: {
            amount: 8,
            probabilities: [0.038, 0.077, 0.038, 0.077, 0.038, 0.077, 0.038, 0.077, 0.05, 0.114, 0.035, 0.05, 0.101, 0.035, 0.05, 0.105],
            rewards: ["a4", "a5", "b2", "b3", "c4", "c5", "d2", "d3", "e3", "e4", "f2", "g4", "g5", "h2", "i4", "i5"]
        },
        stage2: {
            amount: 12,
            probabilities: [0.038, 0.077, 0.038, 0.077, 0.038, 0.077, 0.038, 0.077, 0.05, 0.114, 0.035, 0.05, 0.101, 0.035, 0.05, 0.105],
            rewards: ["a4", "a5", "b2", "b3", "c4", "c5", "d2", "d3", "e3", "e4", "f2", "g4", "g5", "h2", "i4", "i5"]
        }
    }
};

CupsConfig.parseRewards = function (rewards) {
    return (rewards || []).map((res) => {
        const match = res.match(/^([a-zA-Z]+)(\d+)$/);
        return {
            code: match[1],
            stage: Number(match[2])
        };
    });
};

if (typeof cc === "undefined") {
    module.exports = CupsConfig;
}
